import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
export default function BackButton(_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: "pl-4 text-left cursor-pointer flex items-center px-4 py-2 text-primary w-fit font-bold uppercase text-sm", onClick: onClick },
        React.createElement(FontAwesomeIcon, { icon: faArrowLeft, size: 'md' }),
        React.createElement("h1", { className: "ml-2" }, "Back")));
}
